import Error404 from './../pages/errors/Error404App'

import Produtos from './../pages/app/produtos/Index'
import ProdutoShow from './../pages/app/produtos/Show'

const routes = [
	{ path: '*', component: Error404 },
	{
        path: '/',
        name: 'barra',
        component: Produtos,
    },
	{
        path: '/home',
        name: 'home',
        component: Produtos,
    },
    {
        path: '/produtos',
        name: 'produtos',
        component: Produtos,
    },
    {
        path: '/produtos/show/:id',
        name: 'produtosShow',
        component: ProdutoShow,
    },
];

export default routes;